import { grayColors, brandColors, textColors, extraColors } from './colors.mjs';

const lightThemeColors = {
    textColor: grayColors.slate,
    invertedTextColor: grayColors.white,
    mutedTextColor: grayColors.darkGray,
    mutedBackgroundColor: '#f5f5f5',
    buttonTextColor: brandColors.midnightBlue,
    categoryTextColor: brandColors.midnightBlue,
    backgroundColor: grayColors.white,
    iconColor: grayColors.slate,
    videoHeroTextColor: grayColors.white,
    weatherColor1: '#F4A939',
    weatherColor2: '#3693FF',
    weatherColor3: '#3693FF',
    arrowColor: brandColors.midnightBlue,
    lineSeparatorStrongColor: grayColors.slate,
    lineSeparatorMutedColor: grayColors.mist,
    checkboxBorderColor: grayColors.darkGray,
    checkboxBorderHoverColor: grayColors.slate,
    searchBarIconColor: brandColors.midnightBlue,
    navigationRegionBackground: `${grayColors.mist}80`,
    storyContentHeaderColor: brandColors.midnightBlue,
    storyContentLinkColor: brandColors.skyBlue,
    storyContentTableBorderColor: grayColors.slate,
    relatedStoriesBackground: `${grayColors.mist}80`,
    relatedStoriesHeading: brandColors.midnightBlue,
    relatedStoriesTimestamp: grayColors.darkGray,
    mediaCardLoadingBackground: grayColors.mist
};
var lightThemeColors$1 = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, brandColors), grayColors), textColors), extraColors), lightThemeColors);

export { lightThemeColors$1 as default };
//# sourceMappingURL=lightThemeColors.mjs.map
